import React from 'react';
import { useForm } from 'react-hook-form';
import { Card, CardBody, CardHeader, Col, Form, Label, Row } from 'reactstrap';
import { H5, Btn } from '../../../AbstractElements';
import { DebitCardTitle, ExpirationDate, SelectMonthOptions, SelectYearOptions, Submit } from '../../../Constant';

import InputControl from '../../Common/FormInputs/InputControl';

const DebitCard = () => {
  const {register,control,formState: { errors }} = useForm();


  return (
    <>
      <Col xl='4' lg='6' className='box-col-4 debit-card '>
        <Card>
          <CardHeader className='pb-0'>
            <H5>{DebitCardTitle}</H5>
          </CardHeader>
          <CardBody>
            <Form className='theme-form' >
              <Row>
                <Col sm='6' className='p-r-0'>
                  <InputControl label={false} controlInput='input' className='form-control' type='text' errors={errors} placeholder='Firs Name*' register={{ ...register('full_name', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='6'>
                  <InputControl label={false} controlInput='input' className='form-control' type='number' errors={errors} placeholder='Card Number*' register={{ ...register('card_number', { required: 'is Required.', minLength: 16, maxLength: 16 }) }} />
                </Col>
                <Col sm='6' className='p-r-0'>
                  <InputControl label={false} controlInput='input' className='form-control' type='number' errors={errors} placeholder='CVV*' register={{ ...register('cvv_number', { required: 'is Required.', minLength: 3, maxLength: 4 }) }} />
                </Col>
                <Col sm='6'>
                  <InputControl label={false} controlInput='input' className='form-control' type='number' errors={errors} placeholder='CVC*' register={{ ...register('cvc_number', { required: 'is Required.', minLength: 3, maxLength: 4 }) }} />
                </Col>
                <Col sm='12'>
                  <Label className='col-form-label p-b-20'>{ExpirationDate}</Label>
                </Col>
                <Col sm='6 p-r-0'>
                  <InputControl control={control} placeholder='Select Month' label={false} options={SelectMonthOptions} controlInput='select' className='form-select' errors={errors} register={{ ...register('select_month', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='6'>
                  <InputControl control={control} placeholder='Select kiran' label={false} options={SelectYearOptions} controlInput='select' className='form-select' errors={errors} register={{ ...register('select_year', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='12'>
                  <Btn color='primary' className='btn-block' type='submit'>
                    {Submit}
                  </Btn>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default DebitCard;
